
// export enum InformationProvider {
//     PeoWithDisas = 'peoWithDisas';
//     Tutor = 'tutor'
//   }
export class TeacherSurvey{
    id: number;
    staffCode: string;
    fullName: string;
    firstName: string;
    lastName: string;
    gender: number;
    yearOfBirth: number;
    folkId: number;
    yearsOfService: number;
    yearsOfTeaching: number;
    majorId: number;
    qualificationId: number;
    staffUnfostered: boolean;
    staffSurveyCertificates: any[
        // {
        // id: number;
        // staffSurveyId: number;
        // diplomaId: number;
        // }
    ];
    evaluationResult: number;
    staffSurveyTeachingAndSupports: any[
        // {
        // id: number;
        // staffSurveyId: number;
        // teachingAndSupportId: number;
        // hasJoined: boolean;
        // skillLevelId: number;
        // }
    ];
    staffSurveyParticipants: any[
        // {
        // id: number;
        // staffSurveyId: number;
        // participantId: number;
        // hasBuild: boolean;
        // hasMade: boolean
        // }
    ];
    staffSurveyAdjustContents: any[
        // {
        // id: number;
        // staffSurveyId: number;
        // adjustContentId: number;
        // hasMade: boolean;
        // levelBuild: number
        // }
    ];
    staffSurveyFacilitiesAndEquipments: any[
        // {
        // id: number;
        // staffSurveyId: number;
        // facilitiesAndEquipmentId: number;
        // amountStatus: number;
        // quantityStatus: number;
        // }
    ];
    staffSurveyTrainingAndRetraining: any[
        // {
        // id: number;
        // staffSurveyId: number;
        // trainingAndRetrainingId: number;
        // hasJoined: boolean;
        // applied: boolean;
        // resultsInApplied: number;
        // }
    ];
    staffSurveyParticipationModes: any[
        // {
        // id: number;
        // staffSurveyId: number;
        // participationModeId: number;
        // hasMade: boolean
        // }
    ];
    isCoordinationAsfac: boolean;
    coordinationAsfacId: number;
    staffSurveyDifficultyInEducations: any[
        // {
        // id: number;
        // staffSurveyId: number;
        // difficultyInEducationId: number
        // }
    ];
    difficultyInEducationOther: string;
    staffSurveyTeachersDesires: any[
        // {
        // id: number;
        // staffSurveyId: number;
        // teachersDesiresId: number
        // }
    ]
}

export class EducationalStatus{
    id: number;
    code: string;
    text: string;
}
